module.exports = __webpack_public_path__ + "static/img/GR737-FCM-SDW360-BB-1.931f71f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GR737-FCM-SDW360-BB-1.jpg
// module id = Z1MJ
// module chunks = 0